import { Navigate } from 'react-router-dom'
import { useAuth } from '../auth/useAuth'
import { Login } from '../pages/Login'

/** `/login` inside the router (MS-977). Signed out, App's Gate already shows
 * Login on every path; this route matters for the two cases the Gate does
 * not see: an in-router navigation here (SelectAccount's expired pending
 * login), and a signed-in user the Studio hand-off sends to `/login`, who
 * goes Home instead of seeing a sign-in screen for a session they have. */
export function LoginRoute() {
  const { status } = useAuth()
  if (status === 'authenticated') return <Navigate to="/" replace />
  return <Login />
}
